import dmi from './utils/deep-merge-inmutable';
import base from './base';
export default dmi(base, {
    message: {
        userActive: {
            dni: "Identificación",
            cuil: "Identificación",
            cuils: "Identificación",
            module_license: "Usa módulo de vacaciones y ausentismos",
            license_use_module: "Usa módulo de vacaciones y ausentismos",
        },
        label: {
            dni: "Identificación",
        },
        ei_titleList_text_1_3: "Identificación *",
        ei_titleList_text_1_4: "Identificación",
        ei_titleList_text_3_4: "Departamento",
        ei_titleList_text_3_5: "Provincia",
        ei_titleList_text_3_6: "Municipio",
        head_text_table_search_3: "Identificación",
        employees_list_search_desc: "Para realizar una búsqueda puede ingresar el Nombre, Apellido, Identificación o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.",
        search_text_1_1: "Identificación, Nombre, Apellido o Email",
        menu_3: "Vacaciones y Ausentismos",
        menu_8: "Vacaciones y Ausentismos",
        menu_3_1: "Gestión de Vacaciones y Ausentismos",
        uploadImageComponent: {
            body: {
                leftContainer: {
                    filter: {
                        cuil: "Identificación",
                    }
                },
                noContentEmployeeInfo: {
                    noCuil: "No posee Identificación",
                }
            },
            errorLogs: {
                "05115": "La Identificación es requerida",
                "05121": "La Identificación debe contener entre 5 y 15 caracteres alfanuméricos, los caracteres alfanuméricos deben estar en mayúsculas",
                "05127": "La Identificación es duplicada",
            },
        },
        crossSelling: {
            licenses: {
                item_1: "Los empleados podrán solicitar vía mobile o desktop vacaciones y ausentismos",
            },
            toaster: {
                title: "Vacaciones y Ausentismos",
            }
        },
        publishDocuments: {
            configIndivualPublish: {
                inputCuil: {
                    label: "Identificador",
                    question: "¿Cuál es el Identificador del colaborador?",
                    description: "Ingresa el Identificador del colaborador al que quieres enviarle un documento"
                },
            }
        },
        certificates: {
            newCertificate: {
                personalInfo: {
                    dni: "Documento",
                },
                dni: "Documento"
            }
        },
        documentDetail: {
            commons: {
                cuil: "Identificación",
            }
        }
    }
})